/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

import { useAuthentication } from '@hooks/useAuthentication'
import { useUserReadingAction } from '@hooks/userReading/useUserReadingAction'
import { HorizontalStyleProps, WithHorizontalStyleProps } from './interface'

let timeoutId: NodeJS.Timeout | null = null

export function withHorizontalStyle(Component: React.FC<HorizontalStyleProps>) {
  function WithHorizontalStyle({
    isReview = false,
    chapterPages,
    continuePageId,
    chapterId,
  }: WithHorizontalStyleProps) {
    const userReadingClient = useUserReadingAction()
    const [isShowMobileNavigation, setIsShowMobileNavigation] =
      useState<boolean>(false)
    const { isAuthenticated } = useAuthentication()
    const totalPage = chapterPages.length
    const [page, setPage] = useState(1)

    useEffect(() => {
      const onScrollHandler = () => {
        if (timeoutId) {
          clearTimeout(timeoutId)
        }
        if (!isShowMobileNavigation) {
          setIsShowMobileNavigation(true)
        }
        timeoutId = setTimeout(() => {
          setIsShowMobileNavigation(false)
        }, 2000)
      }

      document.addEventListener('scroll', onScrollHandler)
      return () => {
        document.removeEventListener('scroll', onScrollHandler)
      }
    }, [])

    function nextPage() {
      if (page < totalPage) setPage(page + 1)
    }

    function prevPage() {
      if (page > 1) setPage(page - 1)
    }

    useEffect(() => {
      if (isAuthenticated && !isReview) {
        userReadingClient.createUserReading(chapterPages[page - 1].id)
      }
    }, [page, chapterId, isAuthenticated])

    useEffect(() => {
      if (continuePageId) {
        setPage(chapterPages.findIndex(item => item.id === continuePageId) + 1)
      }
    }, [continuePageId])

    const newProps = {
      chapterPages,
      totalPage,
      page,
      nextPage,
      prevPage,
      isShowMobileNavigation,
    }
    return <Component {...newProps} />
  }
  return WithHorizontalStyle
}
